import React from 'react';

const PageNotFound = () => <div>You have just discovered my secret talents</div>;

export default PageNotFound;